var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"movieinfo-originaltitle"},[_vm._v(_vm._s(_vm.props.originalTitle)+" "),_c('span',{staticClass:"movieinfo-releasedate"},[_vm._v("("+_vm._s(_vm.props.releaseDate)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }